import axios from 'axios';
import { API_BASE_URL } from '../config';
import { getAuthTokens } from '../utils/auth';
import api from './middleware';

export const userSettingsApi = {
  // API Keys
  createApiKey: async (description) => {
    try {
      const response = await api.post(
        '/api/user-settings/api-key',
        { description }
      );
      return response.data;
    } catch (error) {
      console.error('Create API key error:', error);
      throw error;
    }
  },

  listApiKeys: async () => {
    try {
      const response = await api.get('/api/user-settings/api-keys');
      return response.data;
    } catch (error) {
      console.error('List API keys error:', error);
      throw error;
    }
  },

  deleteApiKey: async (keyId) => {
    try {
      const response = await api.delete(`/api/user-settings/api-key/${keyId}`);
      return response.data;
    } catch (error) {
      console.error('Delete API key error:', error);
      throw error;
    }
  },

  // Get user settings
  getNotificationEmail: async () => {
    try {
      const response = await api.get('/api/user-settings/notifications-email');
      return response.data;
    } catch (error) {
      console.error('Get notification email error:', error);
      throw error;
    }
  },

  updateNotificationEmail: async (email) => {
    try {
      const response = await api.put(
        '/api/user-settings/notifications-email',
        { notifications_email: email }
      );
      return response.data;
    } catch (error) {
      console.error('Get user settings error:', error);
      throw error;
    }
  }
};